import { render, staticRenderFns } from "./GenerarReportes.vue?vue&type=template&id=63e59aeb"
import script from "./GenerarReportes.vue?vue&type=script&lang=js"
export * from "./GenerarReportes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports